"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFullSsn = void 0;
/**
 * Formats a given value to SSN format.
 * - Removes all non-digit characters.
 * - Trims any whitespace.
 * - Formats based on length:
 *   - If length is less than 4, returns original.
 *   - If length is between 4 and 5, returns in the format `XXX-XX`.
 *   - If length is 6 or more, returns in the format `XXX-XX-XXXX`.
 *
 * @param {string} value - The value to be formatted.
 * @returns {string} - The formatted SSN or original string based on conditions.
 */
const formatFullSsn = (value) => {
    const ssn = value.trim().replace(/[^\d]/g, "");
    if (ssn.length < 4)
        return ssn;
    if (ssn.length < 6)
        return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}`;
    return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5, 9)}`;
};
exports.formatFullSsn = formatFullSsn;
